var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultLayout',[_c('div',{staticClass:"flex flex-wrap w-full mx-auto lg:max-w-6xl lg:min-w-6xl"},[_c('UserNavBar',{staticClass:"flex flex-col w-full md:w-1/3 md:p-2"}),_vm._v(" "),_c('div',{staticClass:"w-full p-3 md:w-2/3"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }